module.exports = __webpack_public_path__ + "static/img/Her2_IMG2.a394909.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/Her2_IMG2.png
// module id = aj2S
// module chunks = 1